export const env: ImportMetaEnv = import.meta.env;

export enum UserType {
  Empty = '',
  CEO = 'CEO',
  CFO = 'CFO',
  Founder = 'FOUNDER',
  ProductManager = 'PRODUCT_MANAGER',
  Developer = 'DEVELOPER',
  Other = 'OTHER',
}

export enum UserIndustry {
  Empty = '',
  Technology = 'TECHNOLOGY',
  Finance = 'FINANCE',
  Healthcare = 'HEALTHCARE',
  Retail = 'RETAIL',
  Manufacturing = 'MANUFACTURING',
  Education = 'EDUCATION',
  Other = 'OTHER',
}

export enum UserCountry {
  Empty = '',
  US = 'US',
  GB = 'GB',
}

export enum OnboardingSteps {
  Init = 'INIT',
  Business = 'BUSINESS',
  Flow = 'FLOW',
  Final = 'FINAL',
}

// New enums for onboarding flow step
export enum PeopleLocation {
  US = 'US',
  UK = 'UK',
  EU = 'EU',
  APAC = 'APAC'
}

export enum CustomerPayments {
  INTERNATIONAL = 'INTERNATIONAL',
  DOMESTIC = 'DOMESTIC',
  US_CANADA = 'US_CANADA'
}

export enum BusinessModel {
  MARKETPLACE = 'MARKETPLACE',
  SERVICE_PLATFORM = 'SERVICE_PLATFORM',
  ECOMMERCE = 'ECOMMERCE',
  SAAS = 'SAAS'
}

export enum SetupState {
  Empty = '',
  AddSeller = 'ADD_SELLER',
  CommissionRule = 'COMMISSION_RULE',
  SimulateTransaction = 'SIMULATE_TRANSACTION',
  Complete = 'COMPLETE'
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  business_name: string;
  avatar: string | null;
  is_onboarding_complete: boolean;
  is_setup_complete: boolean;
  onboarding_state: OnboardingSteps;
  setup_state: SetupState;
}
